import { render } from "./modal-proses.vue?vue&type=template&id=5fd102e2&ts=true"
import script from "./modal-proses.vue?vue&type=script&lang=ts"
export * from "./modal-proses.vue?vue&type=script&lang=ts"

import "./modal-proses.vue?vue&type=style&index=0&id=5fd102e2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__